module.exports = __webpack_public_path__ + "static/img/524af6ad9ef169d363b2d52a8605be59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片3.png
// module id = umcQ
// module chunks = 1